import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import CalculatorRegularIcon from '../../shared/icons/calculator-regular-icon';
import TreadwellBarRow from '../treadwell-bar-row/treadwell-bar-row';

import {
  getTCOMappedValue,
  getTireCostPerMile
} from '../../shared/utils/treadwell/treadwell';

import {
  Maybe,
  ProductData,
  RecommendedArticleData
} from '../../shared/types/graphql-types';
import { COST_PER_MILE_TOOLTIP } from '../../shared/constants/treadwell';

import styles from './cost-per-mile-info.scss';

// TODO: Remove FFRecommendedArticleData when __FF_TREADWELL_GIG_ECONOMY__ is live
interface FFRecommendedArticleData extends RecommendedArticleData {
  totalCost?: Maybe<string>;
  totalCostOfOwnershipRating?: Maybe<string>;
}

interface CostPerMileInfoProps {
  costPerMile?: number;
  product?: ProductData;
  showTooltip?: boolean;
  title?: Maybe<string>;
  tooltip?: Maybe<string>;
  totalCostOfOwnershipRating?: number;
}

function CostPerMileInfo(props: CostPerMileInfoProps) {
  const {
    costPerMile: costPerMileProp,
    product,
    showTooltip = false,
    title: titleProp,
    tooltip: tooltipProp,
    totalCostOfOwnershipRating: totalCostOfOwnershipRatingProp = 0
  } = props;

  const { totalCostOfOwnershipRating = 0 } =
    (product?.recommendationData as FFRecommendedArticleData) || {};

  const costPerMile = getTireCostPerMile(product);

  const formattedValue = (costPerMileProp || costPerMile).toFixed(2);
  const title = titleProp || 'Cost Per Mile';
  const tooltip = tooltipProp || COST_PER_MILE_TOOLTIP;

  const { value } = getTCOMappedValue(
    totalCostOfOwnershipRating,
    totalCostOfOwnershipRatingProp
  );

  return (
    <div className={styles['container']} data-testid="cost-per-mile-info">
      <div className={styles['title']}>
        <CalculatorRegularIcon />
        <Typography weight="bold">{title}</Typography>
        {showTooltip && <Tooltip content={tooltip} />}
      </div>
      <TreadwellBarRow
        className={styles['cost-per-mile']}
        formattedValue={`${formattedValue} cents`}
        hideFill
        maxRatingLabel="lower cost"
        minRatingLabel="higher cost"
        scale={100}
        showValueMarker
        showZeroValue
        value={value}
      />
    </div>
  );
}

export default CostPerMileInfo;
